import { localize } from "../../../services/localize";

import SettingsElement from "../../../ui-components/settings-element/settings-element";

import { Link } from "react-router-dom";

import Spacer from "../../../ui-components/spacer/spacer";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";

const RaindropSettingsLegal = () => {
  return (
    <div className={"flex flex-col h-full overflow-visible gap-4 "}>
      <SettingsElement
        id={"settings-element-legal"}
        title={localize("COPY_SETTINGS_LEGAL")}
        isLocked={false}
        to={"/raindrop/settings"}
      />
      <RaindropDivider />

      <div id={"languages-list"} className={"flex flex-col gap-2"}>
        <Link
          to={"/raindrop/legal/privacy-policy"}
          className="flex flex-row p-4 rounded-lg hover:opacity-90 md:hover:scale-95 transition-all bg-color-background-secondary"
        >
          Privacy Policy
        </Link>
        <Link
          to={"/raindrop/legal/terms-and-conditions"}
          className="flex flex-row p-4 rounded-lg hover:opacity-90 md:hover:scale-95 transition-all bg-color-background-secondary"
        >
          Terms and Conditions
        </Link>
      </div>

      <Spacer />
    </div>
  );
};

export default RaindropSettingsLegal;
